import { ComputedRef } from 'vue'

import { ArenaProblemElement } from '@/domain/entities/arena/arenaProblemElement'
import { ArenaUserEntry } from '@/domain/entities/arena/arenaUserEntry'
import { ArenaViewModel } from '@/presentation/viewmodels/arena/arenaViewModel'
import { ProblemStateViewModel } from '@/presentation/viewmodels/problem/problemStateViewModel'

export class ArenaPresenter {
  private viewModel: ArenaViewModel
  private problemStateViewModel: ProblemStateViewModel

  constructor(viewModel: ArenaViewModel, problemStateViewModel: ProblemStateViewModel) {
    this.viewModel = viewModel
    this.problemStateViewModel = problemStateViewModel
  }

  get arenaId(): ComputedRef<string> {
    return this.viewModel.arenaId
  }

  get arenaProblemId(): ComputedRef<string> {
    return this.viewModel.arenaProblemId
  }

  get arenaProblemIndex(): ComputedRef<number> {
    return this.viewModel.arenaProblemIndex
  }

  get arenaUserEntryList(): ComputedRef<ArenaUserEntry[]> {
    return this.viewModel.arenaUserEntryList
  }

  get arenaProblemElementList(): ComputedRef<ArenaProblemElement[]> {
    return this.viewModel.arenaProblemElementList
  }

  get arenaSolvedProblemList(): ComputedRef<Set<string>> {
    return this.viewModel.arenaSolvedProblemList
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<string | null> {
    return this.viewModel.error
  }

  setArenaProblem(problemId: string, arenaId: string, arenaProblemId: string, arenaProblemIndex: number): void {
    this.viewModel.setArenaProblem(arenaId, arenaProblemId, arenaProblemIndex)
    this.problemStateViewModel.setProblemId(problemId)
  }

  async getByUserIdArenaEntryList(userId: string): Promise<void> {
    await this.viewModel.getByUserIdArenaEntryList(userId)
  }

  async getArenaDetailData(arenaId: string, userId: string): Promise<void> {
    await this.viewModel.getArenaDetailData(arenaId, userId)
  }
}
